import { GetPayoutSummaryResponse } from '@vendasta/billing';

export enum PayoutInterval {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Unknown = 'unknown',
}

export interface PayoutSummary {
  nextInTransitPayout?: Date;
  balances: PayoutBalance[];
  payoutInterval?: PayoutInterval;
  payoutDelayDays: number;
}

export interface PayoutBalance {
  currencyCode: string;
  futurePayouts: number;
  inTransit: number;
}

export function payoutSummaryFromAPI(proto: GetPayoutSummaryResponse): PayoutSummary {
  const zeroDate = new Date('0001-01-01T00:00:00Z').valueOf();
  return {
    nextInTransitPayout:
      proto.nextInTransitPayoutExpectedDate.valueOf() !== zeroDate ? proto.nextInTransitPayoutExpectedDate : undefined,
    payoutInterval: payoutIntervalFromAPI(proto.payoutInterval),
    payoutDelayDays: proto.payoutDelayDays,
    balances: (proto.balances || []).map((balance) => ({
      currencyCode: balance.currencyCode,
      amount: balance.amount || 0,
      futurePayouts: balance.futurePayouts || 0,
      inTransit: balance.inTransit || 0,
    })),
  };
}

export function payoutIntervalFromAPI(proto: string): PayoutInterval | undefined {
  switch (proto) {
    case 'daily':
      return PayoutInterval.Daily;
    case 'weekly':
      return PayoutInterval.Weekly;
    case 'monthly':
      return PayoutInterval.Monthly;
    default:
      return undefined;
  }
}
